import React from "react";

import {
  Archive,
  ArrowCounterClockwise,
  X,
} from "@phosphor-icons/react";


export default function MachineArchiveModal({
  machine,
  action = "archive",
  saving = false,
  onClose,
  onConfirm,
}) {
  if (!machine) {
    return null;
  }

  const isRestore =
    action === "restore";

  const Icon = isRestore
    ? ArrowCounterClockwise
    : Archive;


  return (
    <div
      className="fixed inset-0 z-[80] flex items-center justify-center acta-modal-overlay p-4 backdrop-blur-sm"
      data-testid="machine-archive-modal"
      onMouseDown={onClose}
    >
      <div
        className="acta-modal-surface w-full max-w-lg rounded-2xl border border-[var(--do-border)] bg-[var(--do-bg-solid)] shadow-2xl"
        onMouseDown={(event) =>
          event.stopPropagation()
        }
      >
        <div className="flex items-start justify-between gap-4 border-b border-[var(--do-border)] px-5 py-4">
          <div>
            <div className="label-eyebrow">
              Parc machines
            </div>

            <h2 className="font-heading text-xl font-black tracking-tight">
              {isRestore
                ? "Restaurer la machine"
                : "Archiver la machine"}
            </h2>

            <p className="mt-1 text-sm text-[var(--do-muted)]">
              {machine.name}
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            aria-label="Fermer"
            data-testid="machine-archive-close"
            className="rounded-lg p-2 transition hover:bg-[var(--do-surface-soft)] disabled:opacity-50"
          >
            <X size={20} />
          </button>
        </div>

        <div className="space-y-4 p-5">
          <div
            className={`rounded-xl border px-4 py-3 text-sm ${
              isRestore
                ? "border-[var(--do-border)] bg-[var(--do-accent-soft)] text-[var(--do-ink)]"
                : "border-[var(--do-border)] bg-[var(--do-accent-soft)] text-[var(--do-ink)]"
            }`}
          >
            {isRestore
              ? "La machine redeviendra visible dans le parc actif et pourra être modifiée."
              : "La machine sera masquée du parc actif. Son historique restera conservé."}
          </div>

          <div className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <button
              type="button"
              onClick={onClose}
              disabled={saving}
              className="rounded-lg border border-[var(--do-border)] px-4 py-2 text-sm font-heading font-semibold disabled:opacity-50"
            >
              Retour
            </button>

            <button
              type="button"
              onClick={onConfirm}
              disabled={saving}
              data-testid="machine-archive-submit"
              className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-heading font-bold text-[var(--do-on-accent)] transition disabled:opacity-50 ${
                isRestore
                  ? "bg-[var(--do-accent)] hover:bg-[var(--do-accent-strong)]"
                  : "bg-[var(--do-accent)] hover:bg-[var(--do-accent-strong)]"
              }`}
            >
              <Icon
                size={17}
                weight="bold"
              />

              {saving
                ? "Traitement…"
                : isRestore
                  ? "Restaurer"
                  : "Archiver"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
